import { apiErrorCodes } from 'consts/api/apiErrorCodes';
import { childrenTexts, commonTexts } from 'consts/text';
import { getErrorMessageAndCode } from 'utils/errorHandlers/getErrorMessageAndCode';

export const parentEditEmailErrorParser: (
    error: unknown,
    defaultErrorMessage?: string,
) => string = (error, defaultErrorMessage = childrenTexts.updateParentEmailErrorMessage) => {
    const { code } = getErrorMessageAndCode(error);

    if (code === apiErrorCodes.CHILD_PARENT_EMAIL_DUPLICATE) {
        return childrenTexts.childParentEmailDuplicateErrorMessage;
    }
    if (code === apiErrorCodes.USER_EMAIL_TAKEN) {
        return commonTexts.errorMessages.userEmailTaken;
    }

    return defaultErrorMessage;
};
